import React, { useCallback } from 'react';
import Jodit from 'jodit-react';
import PropTypes from 'prop-types';

const config = {
  readonly: false,
  placeholder: 'Add your note...',
  disablePlugins: 'tab,symbols,stat,sticky,xpath,wrap-nodes,video,tooltip,table-keyboard-navigation,table,spellcheck,speesourcech-recognize,select-cells,select,size,search,resize-handler,resize-cells,about,add-new-line',
  buttons: 'bold,italic,underline,strikethrough,ul,ol,fontsize,paragraph',
  buttonsMD: 'bold,italic,underline,strikethrough,ul,ol,fontsize,paragraph',
  buttonsSM: 'bold,italic,underline,strikethrough,ul,ol,fontsize,paragraph',
  buttonsXS: 'bold,italic,underline,strikethrough,ul,ol,fontsize,paragraph',
};
const Editor = ({ value, setEditorValue }) => {
  const changeText = useCallback((content) => {
    const modal = document.querySelector('.jodit-dialog');

    if (!modal) {
      setEditorValue(content);
    }
  }, [value]);

  return (
    <Jodit
      onBlur={(content) => changeText(content)}
      // onChange={(text) => changeText(text)}
      config={config}
      value={value}
    />
  );
};

Editor.propTypes = {
  value: PropTypes.string.isRequired,
  setEditorValue: PropTypes.func.isRequired,
};

export default Editor;
